import axios from "axios";
import { BannerTypes } from "./Banner.types";
import { environment } from "../../environments/environment";

const API_BASE_NAME = `${environment.apiBaseUrl}`;

const authHeader = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

// 🔹 Get All Banners
export const getAllBanner = async (): Promise<{ data: any[] }> => {
  const res = await axios.get(
    `${API_BASE_NAME}/admin/Get_All_Banner`,
    authHeader()
  );
  return res.data;
};

// 🔹 Create Banner
export const createBanner = async (
  name: string,
  imageFile: File
): Promise<BannerTypes> => {
  const formData = new FormData();
  formData.append("banner_name", name);
  formData.append("banner_image", imageFile);

  const res = await axios.post(
    `${API_BASE_NAME}/admin/Create_Banner`,
    formData,
    {
      headers: {
        ...authHeader().headers,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
};

// 🔹 Delete Banner
export const deleteBannerApi = async (id: number): Promise<void> => {
  await axios.delete(
    `${API_BASE_NAME}/admin/Delete_Banner/${id}`,
    {
      ...authHeader(),
    }
  );
};

// 🔹 Get Banner By Id
export const getBannerById = async (id: number): Promise<BannerTypes> => {
  const res = await axios.get(
    `${API_BASE_NAME}/admin/Get_ById_Banner/${id}`,
    authHeader()
  );

  const data = res.data.data;
  return {
    banner_id: data.banner_id,
    banner_name: data.banner_name,
    banner_image: data.banner_image,
    status: data.status.toLowerCase() === "active" ? "active" : "inactive",
  };
};

// 🔹 Update Banner Status
export const updateBannerStatusApi = async (
  banner_id: number,
  payload: { status: string }
): Promise<void> => {
  try {
    await axios.put(
      `${API_BASE_NAME}/admin/Update_Banner_Status/${banner_id}`,
      payload,
      {
        headers: {
          ...authHeader().headers,
          "Content-Type": "application/json",
        },
      }
    );
    // console.log("✅ status updated successfully!");
  } catch (error: any) {
    console.error(
      "❌ Error updating status:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// 🔹 Update Banner
export const updateBannerApi = async (
  id: number,
  formData: FormData
): Promise<void> => {
  try {
    await axios.put(
      `${API_BASE_NAME}/admin/Edit_Banner/${id}`,
      formData,
      {
        headers: {
          ...authHeader().headers,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // console.log("✅ Banner updated successfully!");
  } catch (error: any) {
    console.error(
      "❌ Error updating Banner:",
      error.response?.data || error.message
    );
  }
};
